<script>
  import AppStoreGridRow from './AppStoreGridRow'

  export default {
    name: 'app-store-grid',

    components: {
      AppStoreGridRow
    },

    props: {
      groups: {
        type: Object,
        required: true
      }
    }
  }
</script>

<template>
  <section class="grid">
    <app-store-grid-row v-for="(apps, index) in groups" :key="index" :heading="index" :apps="apps"/>
  </section>
</template>

<style src="./AppStoreGrid.scss" lang="scss" scoped></style>
